
////////////////////////////////////////////////////////////////////////////////////////////////////
// ZeroPad(23.32, 6) = "023.32"
export function ZeroPad(number, minLength)
{
	return _.padStart(number, minLength, "0");
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// SpaceNumPad(23.32, 6) = " 23.32"
export function SpaceNumPad(number, minLength)
{
	return _.padStart(number, minLength);
	/*
	// Espacio numérico: un 0 de color transparente
	if (!minLength) return number;

	var space = "<span style='color:transparent;text-shadow:none'>0</span>";

	var s = number + "";
	var l = s.length;
	while (l++ < minLength)
		s = space + s;
		
	return s;*/
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// Formato de tiempo estándar para mostrar una vuelta. 
//	- Separar minutos si son necesarios.
//	- Si se indica una longitud mínima se justifica con espacios numéricos.
//
//    23.173
//     4.210
//  1:03.613
export function FormatLapTime(timeInMS)//, minLength)
{
	//var spacedot = "<span style='color:transparent;text-shadow:none'>:</span>";
	//var spacenum = "<span style='color:transparent;text-shadow:none'>0</span>";
	
	var s = timeInMS >= 60000 ? Math.floor(timeInMS / 60000.0) + ":" + ZeroPad(((timeInMS / 1000.0) % 60.0).toFixed(3), 6) : (timeInMS / 1000.0).toFixed(3);
	return s;

	/*
	if (minLength != undefined)
	{
		if (timeInMS < 10000)
		{
			s = spacenum + s;
			minLength--;
			
			if (minLength > 0)
			{
				s = spacedot + s;
				minLength--;
			}
		}
		else if (timeInMS < 60000)
		{
			s = spacedot + s;
			minLength--;
		}
		
		return SpaceNumPad(s, minLength);
	}
	else
	{
		return s;
	}*/
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// Formato de tiempo completo, para mostrar acumulados. Separar minutos siempre.
//
//   0:23.173
//   0:04.210
//   1:03.613
export function FormatFullTime(timeInMS) //, minLength)
{
	var s = Math.floor(timeInMS / 60000.0) + ":" + ZeroPad(((timeInMS / 1000.0) % 60.0).toFixed(3), 6);
	return SpaceNumPad(s, 9);
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// Formato de tiempo largo. Separa horas si es necesario.
/*export function FormatLongTime(timeInMS, minLength)
{
	if (timeInMS >= 3600000)
	{
		var s = Math.floor(timeInMS / 3600000.0) + "h "
			+ ZeroPad(Math.floor((timeInMS / 60000.0) % 60.0), 2) + ":" 
			+ ZeroPad(((timeInMS / 1000.0) % 60.0).toFixed(3), 6);
		
		return SpaceNumPad(s, minLength);
	}
	else
	{
		return FormatStandardTime(timeInMS, minLength);
	}
}*/

////////////////////////////////////////////////////////////////////////////////////////////////////
// Formato de tiempo corto para mostrar diferencias. No separa minutos y muestra el primer decimal 
// SIN redondear.
//
//     23.1
//      4.2
//     63.6
/*export function FormatShortTime(timeInMS, minLength)
{
	var s = (Math.floor(timeInMS / 100.0) / 10.0).toFixed(1);
	return SpaceNumPad(s, minLength)
}*/

////////////////////////////////////////////////////////////////////////////////////////////////////
// Formato de tiempo corto detallado para mostrar diferencias hasta milisegundos. 
// No separa minutos.
//
//    23.173
//     4.210
//    63.613
/*export function FormatShortTimeMs(timeInMS, minLength)
{
	var s = (timeInMS/1000.0).toFixed(3);
	return SpaceNumPad(s, minLength)
}*/

////////////////////////////////////////////////////////////////////////////////////////////////////
// Formato de tiempo de reloj. Minutos y segundos con 00, sin decimales
//
//     00:23
//     00:04
//     01:03
export function FormatClockTime(timeInMS)
{
	return ZeroPad(Math.floor(timeInMS / 60000.0), 2) + ":" + ZeroPad(Math.floor((timeInMS / 1000.0) % 60.0), 2);
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// Formato de tiempo en horas. Sólo horas más un decimal.
//
//     90.0h
//      0.1h
//    234.6h
/*export function FormatTimeHours(timeInMS, minLength)
{
	var s = (timeInMS / 3600000.0).toFixed(1) + "h";
	
	return SpaceNumPad(s, minLength);
}*/



// WEBPACK FOOTER //
// ./client/components/util/timeformat.js